<!--We dispatchen hier gewoon keihard op het gewenste component, zodat we maar één applicatie hebben -->
<div class="wpaipska">
  @switch (startupcomponent) {
    @case ("admin") {
      <div class="wpaipska_header">
        <h4>Professioneel Studiekeuzeadvies - Studiebank</h4>
        <div class="wpaipska_menu">
          <button class="btn btn-secondary" data-bs-toggle="button" [class.active]="adminstate === 'studiebank'"
                  (click)="adminstate ='studiebank'">Studiebank
          </button>
        </div>
      </div>
      <div class="wpaipska_content">
        <!-- plaats de juiste component -->
        @switch (adminstate) {
          @case('studiebank'){
            <studiebank></studiebank>
          }
        }
      </div>
    }
    @case ("rapportselectie") {
      <rapport-selectie></rapport-selectie>
    }
    @default {
      Professioneel studiekeuze advies Studiebank-tool (c) 2024 Spin in het Web B.V.<br>
      Missende optie
    }
  }
</div>
